import {HistoryFilterEnum} from 'presentation/modules/myAppointments/constants/historyFilterEnum';
import {translations} from 'presentation/translations-new';

const {healthAppointment, teleHealth, emergency, surgery} = translations['pt-br'].commons;

const TAG_TITLE = {
	[HistoryFilterEnum.HEALTH]: healthAppointment,
	[HistoryFilterEnum.TELEHEALTH]: teleHealth,
	[HistoryFilterEnum.EMERGENCY]: emergency,
	[HistoryFilterEnum.SURGERY]: surgery,
};

export {TAG_TITLE};
